"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.meApiClient = meApiClient;
const index_const_1 = require("../index.const");
const infra_1 = require("../infra");
const axios_client_1 = require("@invivodf/axios-client");
function meApiClient(apiHost, options) {
    const logger = options.logger ?? index_const_1.NOOP_LOGGER;
    const client = (0, axios_client_1.createAxiosClient)(apiHost, options);
    async function getCurrentPermissions() {
        try {
            const response = await client.get('/v1/me/permissions');
            return response.data;
        }
        catch (err) {
            if (err instanceof Error)
                logger.debug('%s', err.stack);
            (0, infra_1.handleError)(err);
        }
    }
    return {
        getCurrentPermissions
    };
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibWUuY2xpZW50LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL21lL21lLmNsaWVudC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQVNBLGtDQWtCQztBQTFCRCxnREFBNEM7QUFDNUMsb0NBQXNDO0FBQ3RDLHlEQUE4RTtBQU05RSxTQUFnQixXQUFXLENBQUMsT0FBZSxFQUFFLE9BQTJCO0lBQ3RFLE1BQU0sTUFBTSxHQUFHLE9BQU8sQ0FBQyxNQUFNLElBQUkseUJBQVcsQ0FBQTtJQUU1QyxNQUFNLE1BQU0sR0FBRyxJQUFBLGdDQUFpQixFQUFDLE9BQU8sRUFBRSxPQUFPLENBQUMsQ0FBQTtJQUVsRCxLQUFLLFVBQVUscUJBQXFCO1FBQ2xDLElBQUksQ0FBQztZQUNILE1BQU0sUUFBUSxHQUFHLE1BQU0sTUFBTSxDQUFDLEdBQUcsQ0FBa0Isb0JBQW9CLENBQUMsQ0FBQTtZQUN4RSxPQUFPLFFBQVEsQ0FBQyxJQUFJLENBQUE7UUFDdEIsQ0FBQztRQUFDLE9BQU8sR0FBRyxFQUFFLENBQUM7WUFDYixJQUFJLEdBQUcsWUFBWSxLQUFLO2dCQUFFLE1BQU0sQ0FBQyxLQUFLLENBQUMsSUFBSSxFQUFFLEdBQUcsQ0FBQyxLQUFLLENBQUMsQ0FBQTtZQUN2RCxJQUFBLG1CQUFXLEVBQUMsR0FBRyxDQUFDLENBQUE7UUFDbEIsQ0FBQztJQUNILENBQUM7SUFFRCxPQUFPO1FBQ0wscUJBQXFCO0tBQ3RCLENBQUE7QUFDSCxDQUFDIn0=